export const BASE_URL = 'https://images.domaincer.com/images';

// export const BASE_URL = 'https://localhost:3000/';
